export const styles = {
	wrapper: {
		width: '100%',
		maxWidth: '1119px',
	},

	popup: {
		display: 'flex',
		flexDirection: 'column',
		gap: '16px',
		padding: '20px',
		height: '100%',
	},

	drawer: {
		'@media (min-width: 1200px)': {
			display: 'none',
		},
	},
};
